export default function getFilterRuleForAiAlertRootCause(index, rootCauseItem, rootCauseLabel, field, value, key) {
  // ai alert gatway considers all the cities with the same name in their gateway
  // to show similar data, we form or query for all the cities
  // eg city name Austin(.24667) has multiple entries in
  // lookup_city table. There are many cities with the same name in different state/ countries
  // till alert gateway figures out a way to distinguisgh and
  // come up with the solution, we will query for all the cities with this city id

  if (Array.isArray(value)) {
    const orFilter = {};
    value.forEach((cityCode, cityIndex) => {
      orFilter[`${rootCauseItem}$$0_${cityIndex}`] = {
        display: rootCauseLabel,
        field: 'GEO_CITY',
        key: '',
        op: 'eq',
        value: cityCode,
        _order: 0,
      };
    });

    return orFilter;
  }

  return {
    [`${rootCauseItem}$$0_${index}`]: {
      field,
      op: 'eq',
      value,
      key,
      display: rootCauseLabel,
      _order: index,
    },
  };
}
